import {FC, useContext} from "react";
import {useHistory} from "react-router-dom"
import {Link, ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {DisplayDesignItem} from "../../api/response/DisplayDesign";
import {AppContext} from "../../App";

type Props = {
  designs: DisplayDesignItem[]
}
export const CreateDesignItem: FC<Props> = ({designs}) => {
  const {dispatch} = useContext(AppContext);
  const history = useHistory()

  const handleClick = () => {
    const threshold = 6
    if (designs.length >= threshold) {
      dispatch({
        type: "setError",
        payload: {error: true, message: `画面デザインの数が上限(${threshold})に達しています。`}
      });
      return
    }

    history.push("./display_design?id=new")
  }

  return <Link onClick={handleClick}>
    <MenuItem>
      <ListItemIcon>
        <AddIcon/>
      </ListItemIcon>
      <ListItemText>
        新しく作る
      </ListItemText>
    </MenuItem>
  </Link>
}